import { FileMonitoring } from './../../model/file-monitoring.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ApiResponse, DataStream } from '../../model';
import { map, catchError } from 'rxjs/operators';
import { HttpErrorHandler } from '../../../utils/http-error-handler';
import { ResponseHandler } from '../../../utils/responce-handler';

@Injectable()
export class BackEndDataStreamsService {

    url = environment.url;
    constructor(private http: HttpClient) {

    }
    getBackEndDataStream() {
        return this.http.get<ApiResponse<DataStream[]>>(`${this.url}/vehicles/backendDatastream`)
            .pipe(
                map(data => {
                    return ResponseHandler.processData<DataStream[]>(data);
                }, catchError(HttpErrorHandler.handleError))
            )
    }

    getFileMonitoringCount(body: { startDate: string, endDate: string, result: string[], sourceSystem: string[], vin: string }) {
        return this.http.post<ApiResponse<number>>(`${this.url}/vehicles/getFileMonitoringCount`, body)
            .pipe(
                map(data => {
                    return ResponseHandler.processData<number>(data);
                }, catchError(HttpErrorHandler.handleError))
            )
    }

    getFileMonitoring(pageNo: number, countPerPage: number, body: { startDate: string, endDate: string, result: string[], sourceSystem: string[], vin: string }) {
        return this.http.post<ApiResponse<FileMonitoring[]>>(`${this.url}/vehicles/getFileMonitoring/${pageNo}/${countPerPage}`, body)
            .pipe(
                map(data => {
                    return ResponseHandler.processData<FileMonitoring[]>(data);
                }, catchError(HttpErrorHandler.handleError))
            )
    }
}